import { render, staticRenderFns } from "./platformAuth.vue?vue&type=template&id=04187ba1&scoped=true&"
import script from "./platformAuth.vue?vue&type=script&lang=js&"
export * from "./platformAuth.vue?vue&type=script&lang=js&"
import style0 from "./platformAuth.vue?vue&type=style&index=0&id=04187ba1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04187ba1",
  null
  
)

export default component.exports